module.exports = __webpack_public_path__ + "static/media/insPicTwo.a151c244.jpg";